import styled from 'styled-components'
import { secondaryFont } from '../../../assets/consts/fonts'
import { brandOrange } from '../../../assets/consts/color'

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 100px 1fr 100px 1fr 100px;
  column-gap: 50px;
  row-gap: 50px;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 80px 1fr 80px;
    column-gap: 40px;
    row-gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 30px;
  }
`

export const Step = styled.div`
  font-family: ${secondaryFont};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  position: relative;

  h3,
  p {
    margin: 0;
  }

  @media (max-width: 1400px) {
    gap: 20px;
  }
`

export const StepTitle = styled.h3`
  color: ${brandOrange};
  font-weight: 600;
  font-size: 24px;
  width: 100%;
  text-align: center;

  @media (max-width: 1400px) {
    font-size: 20px;
  }
`

export const StepDescription = styled.p`
  font-weight: 400;
  font-size: 18px;
  width: 100%;
  text-align: center;

  @media (max-width: 1400px) {
    font-size: 16px;
  }
`

export const StepImageWrapper = styled.div`
  border-radius: 50%;
  border: 1px solid rgba(128, 128, 128, 0.5);

  width: 250px;
  height: 250px;

  display: grid;
  place-content: center;

  @media (max-width: 1400px) {
    width: 180px;
    height: 180px;
  }
`

export const StepImage = styled.img`
  width: 125px;

  @media (max-width: 1400px) {
    width: 80px;
    height: 80px;
  }
`

export const StepDivider = styled.img`
  //position: absolute;
  width: 100px;
  transform: rotate(90deg);
  margin-top: 80px;
  align-self: baseline;

  @media (max-width: 1400px) {
    margin-top: 60px;
    width: 70px;
  }

  @media (max-width: 768px) {
    transform: rotate(180deg);
    margin: 0 auto;
  }
`
